/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{overflow:auto;width:100%}[_nghost-%COMP%]   .back-and-save-btn[_ngcontent-%COMP%]{background:#f44336!important;border-radius:unset!important;border-right:1px solid #fff}[_nghost-%COMP%]   fuse-sidebar[_ngcontent-%COMP%]{box-shadow:none}@media screen and (max-width:599px){[_nghost-%COMP%]   .happ-form-container-div[_ngcontent-%COMP%]{width:100%!important}}"];
export { styles as styles };
